import Reveal from "@/components/Reveal";
import { GraduationCap, Award, BookOpen } from "lucide-react";

const PORTRAIT =
  "https://images.unsplash.com/photo-1519824145371-296894a0daa9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwyfHxwaHlzaW90aGVyYXBpc3QlMjBtYXNzYWdlJTIwaGFuZHN8ZW58MHx8fHwxNzkyMTgxNTMzfDA&ixlib=rb-4.1.0&q=85";

const CREDENTIALS = [
  { icon: GraduationCap, text: "Laurea in Fisioterapia, Università degli Studi di Torino" },
  { icon: Award, text: "Iscritto all'Albo TSRM-PSTRP n. 4351" },
  { icon: BookOpen, text: "Formazione continua con corsi specialistici: specializzato nel trattamento delle persone anziane e dei problemi muscolo-scheletrici" },
];

const STATS = [{ value: "500+", label: "pazienti seguiti" }];

export default function About() {
  return (
    <section id="chi-sono" data-testid="about-section" className="py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-terracotta mb-4">Chi sono</p>
          <h2 className="font-serif tracking-tight text-pine text-3xl sm:text-4xl lg:text-5xl max-w-2xl">
            Il recupero è un viaggio che facciamo insieme.
          </h2>
          <p className="mt-6 text-base lg:text-lg text-moss leading-relaxed max-w-3xl">
            Maestro e allenatore di sci alpino, ho frequentato la facoltà di Scienze Motorie prima di
            laurearmi in Fisioterapia. Collaboro con un poliambulatorio e una RSA: un'esperienza
            profonda e varia, che mi permette di prendermi cura di patologie e pazienti molto diversi
            tra loro, sempre con un piano costruito sulla persona.
          </p>
        </Reveal>
        <div className="mt-14 grid lg:grid-cols-12 gap-6">
          <Reveal className="lg:col-span-5 relative" delay={0.1}>
            <div className="absolute -bottom-5 -left-5 w-full h-full bg-terracotta/25 rounded-md" aria-hidden="true" />
            <img
              src={PORTRAIT}
              alt="Trattamento di fisioterapia, terapia manuale sulla schiena"
              data-testid="about-portrait"
              className="relative w-full aspect-[4/5] lg:aspect-auto lg:h-full object-cover rounded-md"
            />
          </Reveal>
          <div className="lg:col-span-7 flex flex-col gap-6">
            <div className="grid sm:grid-cols-2 gap-6 h-full">
              <Reveal delay={0.2}>
                <div className="border border-pine/10 rounded-md p-6 h-full">
                  <p className="text-xs font-bold uppercase tracking-[0.18em] text-moss mb-4">Formazione</p>
                  <ul className="space-y-4">
                    {CREDENTIALS.map((c) => (
                      <li key={c.text} className="flex items-start gap-3 text-sm text-pine leading-relaxed">
                        <c.icon size={17} strokeWidth={1.5} className="text-terracotta shrink-0 mt-0.5" />
                        {c.text}
                      </li>
                    ))}
                  </ul>
                </div>
              </Reveal>
              <Reveal delay={0.25}>
                <div className="flex flex-col gap-6 h-full">
                  {STATS.map((s) => (
                    <div key={s.label} data-testid={`stat-${s.value}`} className="flex-1 bg-pine text-bone rounded-md p-6 flex flex-col justify-center">
                      <p className="font-serif text-4xl">{s.value}</p>
                      <p className="text-xs uppercase tracking-[0.16em] text-bone/70 mt-2">{s.label}</p>
                    </div>
                  ))}
                </div>
              </Reveal>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
